import { useContext, useMemo } from "react";
import { ReportImageNavigation } from "~/components/common/reports/navigation/ReportImageNavigation";
import { OwnStatusHandleButtons } from "~/components/common/statuses/OwnStatusHandleButtons";
import { useDealContext } from "~/context/DealContext";
import { useDealCompletionReportImages } from "~/hooks/deals/useDealCompletionReportImages";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import { hasPermissionToMoveStatus } from "~/models/Staff";
import {
	OWN_AWAITING_ACCEPTANCE,
	OWN_FINISHED,
	OWN_IN_CONSTRUCTION,
	ownStatusMovingValidation
} from "~/models/Status";
import { PATH as COMPLETION_REPORT_PATH } from "~/pages/deals/[id]/completion_reports";
import Styles from "./statuses.module.scss";

export function OwnAwaitingAcceptance() {
	const deal = useDealContext();
	const account = useContext(ItandiAccountContext);
	const { data: reportImages } = useDealCompletionReportImages().index(deal.id);
	const forwardDisabled = useMemo(
		() => !ownStatusMovingValidation[OWN_AWAITING_ACCEPTANCE](account),
		[account]
	);
	// 完了へ進める時のみ完了権限が必要。工事完了待ちへ戻す時はステータス変更権限のみで判定する
	const backwardDisabled = useMemo(
		() => !hasPermissionToMoveStatus(account),
		[account]
	);
	return (
		<div>
			<h3 className={Styles.Title}>工事が完了しました</h3>
			<p className={Styles.Description}>
				完了報告画像を確認いただき、問題なければステータスを進めてください。
			</p>
			{reportImages !== null && (
				<ReportImageNavigation
					detailPageButtonLabel="画像確認画面"
					detailPagePath={COMPLETION_REPORT_PATH(deal.id)}
					reportImages={reportImages}
					title="完了報告画像を確認してください"
				/>
			)}
			<OwnStatusHandleButtons
				backwardDisabled={backwardDisabled}
				forwardDisabled={forwardDisabled}
				nextStatusId={OWN_FINISHED}
				prevStatusId={OWN_IN_CONSTRUCTION}
			/>
		</div>
	);
}
